
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1024","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M711.111 625.778h-44.942l-15.929-15.36c55.751-64.853 89.316-149.049 89.316-240.64C739.556 165.547 574.009 0 369.778 0S0 165.547 0 369.778c0 204.231 165.547 369.778 369.778 369.778 91.591 0 175.787-33.564 240.64-89.316l15.36 15.929v44.942l284.444 283.876 84.764-84.764L711.11 625.779zm-341.333 0c-141.653 0-256-114.347-256-256s114.347-256 256-256c141.653 0 256 114.347 256 256s-114.347 256-256 256z"}})])
          )
        }
      }
    